import { parseAsEstree } from "./parse.js";
import { precook } from "./precook.js";
let ASTCache = new WeakMap();
export function precookFunction(source) {
  let {
    typescript,
    cacheKey,
    ...restOptions
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let func = cacheKey ? ASTCache.get(cacheKey) : undefined;
  if (!func) {
    func = parseAsEstree(source, {
      typescript
    });
    if (cacheKey) {
      ASTCache.set(cacheKey, func);
    }
  }
  const attemptToVisitGlobals = precook(func, restOptions);
  return {
    function: func,
    attemptToVisitGlobals
  };
}
export function clearFunctionASTCache() {
  ASTCache = new WeakMap();
}
//# sourceMappingURL=precookFunction.js.map